var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpwardsDarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 16,
    d: "M4.35373 0.146447L7.85391 3.64663C8.04917 3.84189 8.04917 4.15847 7.85391 4.35373C7.65865 4.54899 7.34207 4.54899 7.1468 4.35373L4.5 1.707V11.5417C4.5 11.7948 4.27614 12 4 12C3.72386 12 3.5 11.7948 3.5 11.5417V1.707L0.853553 4.35373C0.658291 4.54899 0.341709 4.54899 0.146447 4.35373C-0.0488155 4.15847 -0.0488155 3.84189 0.146447 3.64663L3.64663 0.146447C3.84189 -0.0488155 4.15847 -0.0488155 4.35373 0.146447Z",
    fill: "#113601"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardsDarkGreen);
export default __webpack_public_path__ + "static/media/UpwardsDarkGreen.6d9e98de78a28dcb07c2d6409dbabe96.svg";
export { ForwardRef as ReactComponent };